import { createSelector } from '@reduxjs/toolkit';
import { get, isNil } from 'lodash/fp';
import { selectSelectedEntityId, selectProject } from 'app/store/projects/selectors.js';
import { selectQueryMetadataForPropEntityId } from 'app/store/snowflakeQueries/selectors.js';

const selectPropEntityId = (_, props) => props?.entityId;

const selectCurrentDatasetError = createSelector(selectQueryMetadataForPropEntityId, get('error'));

const selectIsCurrentDatasetSelected = createSelector(
    selectPropEntityId,
    selectSelectedEntityId,
    (currentDatasetEntityId, selectedEntityId) => currentDatasetEntityId === selectedEntityId
);

export const selectSelectedDatasetHasError = createSelector(
    selectIsCurrentDatasetSelected,
    selectCurrentDatasetError,
    (isCurrentDatasetSelected, currentDatasetError) =>
        isCurrentDatasetSelected && !isNil(currentDatasetError)
);

export const selectColumns = createSelector(
    selectProject,
    selectSelectedEntityId,
    selectPropEntityId,
    (space, selectedEntityId, propEntityId) => {
        const uid = (propEntityId ?? selectedEntityId).split('.')[1];

        return space.schemasByUid[uid]?.columns;
    }
);
